import classNames from 'classnames';
import { type ReactNode, useId } from 'react';

import { useOrderedStepContext } from './useOrderedStepContext';

import './OrderedStep.css';

export type OrderedStepProps = {
  title: ReactNode;
  children: ReactNode;
};

export const OrderedStep = ({ title, children }: OrderedStepProps) => {
  const labelId = useId();
  const { fit } = useOrderedStepContext();

  return (
    <li aria-labelledby={labelId} className="OrderedStep">
      <div className="OrderedStep__separator" role="presentation">
        <div className="OrderedStep__dot" />
      </div>

      <div
        className={classNames(
          'OrderedStep__content',
          fit === 'parent' && 'OrderedStep__contentGrow',
        )}
      >
        <div className="OrderedStep__title" id={labelId}>
          {title}
        </div>
        <div className="OrderedStep__children">{children}</div>
      </div>
    </li>
  );
};
